import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'

type GoalOutlineProps = {
    top?: number
    bottom?: number
    width: number
}

const GOAL_HEIGHT = 70

const GoalOutline: FC<GoalOutlineProps> = ({ top, bottom, width }) => (
    <Grid position="absolute" top={top} bottom={bottom} width={width} height={GOAL_HEIGHT}>
        <Grid width={140} height={GOAL_HEIGHT} marginX="auto" border={2} borderColor="WHITE" />
    </Grid>
)

export default GoalOutline
